import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import FormValidation from "../../commons/validation/FormValidation.js";
import Validator from "../../commons/validation/Validator.js";
import Loading from "../ui/Loading.js";

import moment from "moment";
import "moment/min/locales";
import Switch from "react-switch";
import AjaxHandler from "../../commons/ajax/AjaxHandler.js";
import AtributoDinamico from "../atributoDinamico/AtributoDinamico.js";
import * as Constants from "../atributoDinamico/constants.js";
import { FormattedMessage, injectIntl } from "react-intl";
import backendStrings from "../../lang/backendStrings.js";
import Select from "react-select";
import { DragDropContext } from "react-beautiful-dnd";
import { Droppable } from "react-beautiful-dnd";
import ConfigBusiness from '../../commons/config/ConfigBusiness.js'

const ICONS = [
	"fa fa-car",
	"fa fa-truck",
	"fa fa-bus",
	"fa fa-motorcycle",
	"fa fa-user",
	"fa fa-users",
	"fa fa-wrench",
	"fa fa-cog",
	"fa fa-map-marker",
];

class ConfiguracionAbm extends Component {
	constructor(props) {
	super(props);
	this.ajaxHandler = new AjaxHandler();

	moment.locale('es');

		this.state = {
			redirectTo: null,
			props: this.props,
			formData: {
				nombre: '',
				icono: 'fa fa-car',
				descripcion: '',
				con_medidor: false,
				con_persona: false,
				con_movil: true,
				con_chofer: false,
				con_transportadora: false,
				con_ticket: false,
				exclusivoApp: false,
				activo: true,
				atributos_dinamicos: [],
				perfiles: [],
				perfiles_responder: [],
				perfil_notificar_activo: false,
				movil_atributos: [],
				administracion_de_atributos: [],
				movil_estados_disponibles: [],
				ticket_atributos: [],
				autogestion: false
			},
			movil_estados: [],
				estados: [
				{
					id: 1,
					nombre: this.props.intl.formatMessage({
					id: "safeFeedbackTipoFormularioAbm.state_name_activo",
					defaultMessage: "Activo",
					}),
				},
				{
					id: 0,
					nombre: this.props.intl.formatMessage({
					id: "safeFeedbackTipoFormularioAbm.state_name_inactivo",
					defaultMessage: "Inactivo",
					}),
				},
			],
			administracion_de_atributos: [
				{
					id: 'base',
					nombre: this.props.intl.formatMessage({
						id: "safeFeedbackTipoFormularioAbm.select_administracion_de_atributos.base",
						defaultMessage: "Base",
					}),
				}
			],
		
			errors: [],
			perfilesSelect: [],
			loading: false,
			mostrarInactivos: ConfigBusiness.get('checklist.atributosDinamicos.mostrarInactivos') === 'true' ? true : false,
		};

		this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
		this.handleChangeAtributoDinamico = this.handleChangeAtributoDinamico.bind(this);
		this.handleAddAtributoDinamico = this.handleAddAtributoDinamico.bind(this);
		this.handleDeleteAtributoDinamico = this.handleDeleteAtributoDinamico.bind(this);
		this.handleInputFormChange = this.handleInputFormChange.bind(this);
		this.handleIconChange = this.handleIconChange.bind(this)
		this.handlePerfilChange = this.handlePerfilChange.bind(this)
		this.handlePerfilResponderChange = this.handlePerfilResponderChange.bind(this);
		this.handleAtributo = this.handleAtributo.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.onDragEnd = this.onDragEnd.bind(this);

		this.formValidation = new FormValidation({
			component: this,
			validators: {
			"formData.nombre": (value) => Validator.notEmpty(value),
			},
		});
	}

	onDragEnd(result) {
		if (!result.destination || result.destination.droppableId !== "1" ) return;
		this.setState({ loading: true });
		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		let atributos_dinamicos = formDataCopy.atributos_dinamicos;
		let atributoEnMovimiento = atributos_dinamicos[result.source.index];
		atributos_dinamicos.splice(result.source.index, 1);
		atributos_dinamicos.splice(result.destination.index, 0, atributoEnMovimiento);
		this.setState({ formData: formDataCopy }, () => this.setState({ loading: false }));
	}

	handlePerfilChange(perfiles) {
		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy["perfiles"] = perfiles;
		this.setState({
		formData: formDataCopy,
		});
	}

	handlePerfilResponderChange(perfiles) {
		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy["perfiles_responder"] = perfiles;
		this.setState({
		formData: formDataCopy,
		});
	}

	initForm() {
		this.setState({ loading: true });
		let component = this;
		let perfilesSelect = [];
		Promise.all([
			this.state.props.action !== "ADD"
			? this.ajaxHandler.getJson("/safe-feedback-tipo-formularios/" + this.state.props.match.params.id)
			: null,
			this.ajaxHandler.getJson("/perfiles")
		])
		.then((data) => {
		let formDataNew = data[0];
		perfilesSelect = data[1];
		if (formDataNew) {
			if(formDataNew.administracion_de_atributos_json){
				let administracion_de_atributos = [];
				let administracion_de_atributos_array = JSON.parse(formDataNew.administracion_de_atributos_json);
				this.state.administracion_de_atributos.forEach(function(element) {
				if(administracion_de_atributos_array.includes(element.id))
					administracion_de_atributos.push(element);
				})
				formDataNew.administracion_de_atributos = administracion_de_atributos;
			}
			formDataNew.atributos_dinamicos = formDataNew.atributos_dinamicos.map((atributo) => {
			atributo.value = atributo.valorDefault;
			return atributo;
			});
			
		
			component.setState({
			formData: formDataNew,
			});
		} else this.handleAddAtributoDinamico();
		})
		.catch(function (error) {
			component.exit();
		})
		.finally(() => {
		this.setState({
			loading: false,
			perfilesSelect: perfilesSelect,
		});
		});
	}

	componentWillMount() {
		this.ajaxHandler.subscribe(this);
		this.initForm();
	}

	componentWillUnmount() {
		this.ajaxHandler.unsubscribe();
	}

	handleCheckboxChange(name, activo) {
		this.state.formData[name] = activo;
		this.setState({
			formData: this.state.formData,
		});
	}

	handleInputFormChange(event) {
		const target = event.target;
		const name = target.name;
		const value = target.type === 'checkbox' ? target.checked : target.value;

		this.state.formData[name] = value;
		this.setState({
			formData: this.state.formData
		});
	}

	handleAddAtributoDinamico() {
		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		let templateAtributoCopy = JSON.parse(JSON.stringify(Constants.TEMPLATE_ATRIBUTO));
		formDataCopy.atributos_dinamicos.push(templateAtributoCopy);
		this.setState({
			formData: formDataCopy,
		});
	}

	handleDeleteAtributoDinamico(index) {
		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy.atributos_dinamicos.splice(index, 1);
		this.setState({
			formData: formDataCopy,
		});
	}

	handleChangeAtributoDinamico(index, key, value) {
		let atributoDinamico = this.state.formData.atributos_dinamicos[index];
		atributoDinamico[key] = value;
		if (key == "value") atributoDinamico.valorDefault = value;
		this.setState({
			formData: this.state.formData,
		});
	}

	handleIconChange(e, icono) {
		e.preventDefault();
		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy["icono"] = icono;
		this.setState({
			formData: formDataCopy,
		});
	}

	handlePerfilChange(perfiles) {
		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy["perfiles"] = perfiles;
		this.setState({
			formData: formDataCopy,
		});
	}

	handlePerfilResponderChange(perfiles) {
		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy["perfiles_responder"] = perfiles;
		this.setState({
			formData: formDataCopy,
		});
	}
	
	handleAtributo(atributos, name){
		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy[name] = atributos;
		this.setState({
			formData: formDataCopy,
		});
	}

	handleSubmit(event) {
		this.setState({ loading: true });
		let component = this;
		this.state.formData.administracion_de_atributos_json = this.state.formData.administracion_de_atributos ? JSON.stringify(this.state.formData.administracion_de_atributos.map((atributo) => atributo.id)) : null;
		this.state.formData.perfiles_ids = this.state.formData.perfiles.map((perfil) => perfil.id);
		this.state.formData.atributos_dinamicos.map((atributo, index) => {
			atributo.order = index;
			return atributo;
		});
		this.ajaxHandler
			.fetch("/safe-feedback-tipo-formularios" + (this.props.action === "ADD" ? "" : "/" + this.state.formData.id), {
			method: this.props.action === "ADD" ? "POST" : "PUT",
			body: JSON.stringify({
				...this.state.formData,
			}),
			})
			.then((response) => {
				if (response.status !== 400) {
					component.exit();
				} else {
					response.json().then((data) => {
						this.setState({
							errors: data.detalle,
						});
					});
				}
				window.scrollTo(0, 0);
			})
			.catch((error) => {
				component.ajaxHandler.handleError(error);
			})
			.finally(() => {
			this.setState({ loading: false });
			});
		event.preventDefault();
	}

	handleCancel(event) {
		this.exit();
	}

	exit() {
		this.setState({
			redirectTo: "/safefeedback-tipo-formularios",
		});
	}

	render() {
	let state = this.state;
	this.formValidation.validate();
	let formData = this.state.formData;
	let validationState = this.formValidation.state;

	return (
		<React.Fragment>
			<div className="content-wrapper">
				<div className="content-body">
					{this.state.redirectTo && <Redirect push to={this.state.redirectTo} />}
					{this.state.loading && <Loading />}
					<div className="row">
						<div className="col-md-12">
							<div className="alert alert-danger" role="alert" hidden={this.state.errors.length === 0}>
								{this.state.errors.map((e, i) => (
									<li key={i}>
									<FormattedMessage {...(backendStrings[e] ? backendStrings[e] : backendStrings["errors.default"])} />
									</li>
								))}
							</div>
							<form className="form form-horizontal" ref="form" onSubmit={this.handleSubmit}>
								<div className="form-body">
									<div className="card pull-up">
										<div className="card-content">
											<div className="card-body">
												<h4 className="form-section">
													<i className="icon-home"></i>
													<FormattedMessage
														id="safeFeedbackTipoFormularioAbm.render.general_data.header_datos_generales"
														defaultMessage=" Datos Generales "
													/>
													<div className="float-right" style={{ fontSize: "14px" }}>
														<FormattedMessage
															id="safeFeedbackTipoFormularioAbm.render.general_data.campos_requeridos"
															defaultMessage="* campos requeridos"
														/>
													</div>
												</h4>

												<div className="row">
													{/* Nombre */}
													<div className="col-md-6">
														<div className="form-group row">
															<label className="col-md-3 label-control col-form-label" htmlFor="nombre">
																<FormattedMessage
																	id="safeFeedbackTipoFormularioAbm.render.general_data.label_nombre"
																	defaultMessage="Nombre *:"
																/>
															</label>
															<div className="col-md-9">
																<input
																	disabled={this.props.action === "VIEW"}
																	type="text"
																	className="form-control"
																	id="nombre"
																	name="nombre"
																	placeholder={this.props.intl.formatMessage({
																		id: "safeFeedbackTipoFormularioAbm.render.general_data.placeholder_nombre",
																		defaultMessage: "Modelo",
																	})}
																	value={formData.nombre}
																	onChange={this.handleInputFormChange}
																/>
																<div
																	className="help-block text-danger field-message"
																	hidden={
																	validationState.formData.nombre.pristine || validationState.formData.nombre.valid
																	}
																>
																	{validationState.formData.nombre.message}
																</div>
															</div>
														</div>
													</div>
												</div>
												<div className="row">
													{/* Descripción */}
													<div className="col-md-6">
														<div className="form-group row">
															<label className="col-md-3 label-control col-form-label" htmlFor="descripcion">
															<FormattedMessage
																id="safeFeedbackTipoFormularioAbm.render.general_data.label_descripcion"
																defaultMessage="Descripción:"
															/>
															</label>
															<div className="col-md-9">
																<textarea
																	disabled={this.props.action === "VIEW"}
																	className="form-control"
																	id="descripcion"
																	name="descripcion"
																	value={formData.descripcion}
																	onChange={this.handleInputFormChange}
																></textarea>
															</div>
														</div>
													</div>
												</div>
												<div className="row">
													{/* Perfil */}
													<div className="col-md-6">
														<div className="form-group row">
															<label className="col-md-3 label-control col-form-label" htmlFor="perfiles">
																<FormattedMessage id="SafeFeedbackTipoFormularioAbm.render.general_data.label_perfil_notificar" defaultMessage="Perfil a Notificar"/>:
															</label>
															<div className="col-md-9">
																<Select
																	placeholder="Seleccione"
																	options={this.state.perfilesSelect}
																	valueKey="id"
																	labelKey="nombre"
																	multi
																	value={formData.perfiles}
																	onChange={(e) => this.handlePerfilChange(e)}
																	disabled={this.state.props.action === "VIEW"}
																/>
															</div>
														</div>
													</div>
												</div>
												<div className="row">
													{/* Atributos de vehículo */}
													<div className="col-md-6">
														<div className="form-group row">
															<label className="col-md-3 label-control col-form-label" htmlFor="administracion_de_atributos">
																<FormattedMessage id="SafeFeedbackTipoFormularioAbm.render.general_data.label_administracion_de_atributos" defaultMessage="Administracion de Atributos"/>:
															</label>
															<div className="col-md-9">
																<Select
																	placeholder="Seleccione"
																	options={this.state.administracion_de_atributos}
																	valueKey="id"
																	labelKey="nombre"
																	multi
																	value={formData.administracion_de_atributos}
																	onChange={(e) => this.handleAtributo(e, "administracion_de_atributos")}
																	disabled={this.state.props.action === "VIEW"}
																/>
															</div>
														</div>
													</div>
												</div>
												
												<div className="row">
													{/* ESTADO */}
													<div className="col-md-6">
														<div className="form-group row">
															<label className="col-md-3 label-control col-form-label" htmlFor="activo">
															<FormattedMessage
																id="safeFeedbackTipoFormularioAbm.render.general_data.label_activo"
																defaultMessage="Activo:"
															/>
															</label>
															<div className="col-md-9 mt-auto">
																<Switch
																	onChange={(value) => this.handleCheckboxChange("activo", value)}
																	checked={formData.activo}
																	options={this.state.estados}
																	id="activo"
																	name="activo"
																	valueKey="id"
																	labelKey="nombre"
																	disabled={this.state.props.action === "VIEW" ? true : false}
																	offColor="#FF4961"
																	onColor="#28D094"
																/>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									{!this.state.loading && (
										<DragDropContext onDragEnd={this.onDragEnd}>
											<Droppable droppableId={"1"}>
											{(provided, snapshot) => (
												<div
													ref={provided.innerRef}
													{...provided.droppableProps}
													style={snapshot.isDraggingOver ? { background: "lightblue" } : {}}
												>
												{this.state.formData.atributos_dinamicos.map(
													(atributoDinamico, index) =>
													atributoDinamico &&
													(atributoDinamico.activo || this.state.mostrarInactivos) && (
														<AtributoDinamico
															mostrarInactivos={this.state.mostrarInactivos}
															handleDelete={this.handleDeleteAtributoDinamico}
															index={index}
															key={index}
															previsualizacion={true}
															modulo={"checklist"}
															safeFeedback={true}
															disabled={this.state.props.action === "VIEW"}
															draggable={this.state.props.action !== "VIEW"}
															handleChange={this.handleChangeAtributoDinamico}
															formulario={atributoDinamico}
															tipoPersona={this.state.formData.con_persona}
															tipoTicket={this.state.formData.con_ticket}
														/>
													)
												)}
												{provided.placeholder}
												</div>
											)}
											</Droppable>
										</DragDropContext>
									)}
									<div className="card pull-up">
										<div className="card-content">
											<div className="card-body">
												<div className="text-cd text-right">
													{this.props.action !== "VIEW" && (
													<>
														<button
															type="button"
															className="btn btn-success pull-left mr-1"
															onClick={this.handleAddAtributoDinamico}
														>
															<i className="fa fa-plus"></i>
															<FormattedMessage
																id="safeFeedbackTipoFormularioAbm.render.add_attribute_button.agregar_atributo_dinamico"
																defaultMessage=" Agregar Atributo Dinámico"
															/>
														</button>
														<button
															type="submit"
															className="btn btn-primary mr-1"
															disabled={!validationState.form.valid}
														>
															<i className="fa fa-check-circle"></i>
															<FormattedMessage
																id="safeFeedbackTipoFormularioAbm.render.finish_button.guardar"
																defaultMessage=" Guardar"
															/>
														</button>
													</>
													)}
													<button type="button" className="btn btn-danger" onClick={this.handleCancel.bind(this)}>
														<i className="fa fa-times-circle"></i>{" "}
														{this.props.action === "VIEW"
															? this.props.intl.formatMessage({
																id: "safeFeedbackTipoFormularioAbm.render.finish_button.volver",
																defaultMessage: "Volver",
															})
															: this.props.intl.formatMessage({
																id: "safeFeedbackTipoFormularioAbm.render.finish_button.cancelar",
																defaultMessage: "Cancelar",
														})}
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
	}
}

export default injectIntl(ConfiguracionAbm);
